@if (contentBlock) {
  <div id="contentblock-{{contentBlock.id}}" class="content-style content-block-content">
    <!-- Challenge block type button -->
    @if (!contentBlock.challengeBlock || !contentBlock.challengeBlock.onlineAssetId) {
      <button type="button"
        class="btn btn-success challenge-btn">
        {{buttonText}}
      </button>
    }
    <!-- Challenge block type image -->
    @if (contentBlock.challengeBlock && contentBlock.challengeBlock.onlineAssetId) {
      <div>
        <img class="challenge-img" onerror="this.src = 'assets/img/loader.gif'" (load)="imageLoaded = true;"
          [hidden]="!imageLoaded"
      src="{{'/api/Assets/Image/' + contentBlock.challengeBlock.onlineAssetId + '?height=150&ratio=' + devicePixelRatio | loadSecureAssets  : true | async }}" />
  </div>
}
</div>
}